import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDetail } from '@services/error.service';

export const RATE_LIMIT_DEFAULT_SECONDS = 15;
export const RATE_LIMIT_MAX_SECONDS = 60;

// Retry-After puede venir en segundos o como fecha HTTP.
export function parseRetryAfter(
  header: string | null | undefined,
  now: number = Date.now()
): number {
  if (!header) return RATE_LIMIT_DEFAULT_SECONDS;
  const trimmed = header.trim();
  let seconds = /^\d+$/.test(trimmed)
    ? Number(trimmed)
    : Math.ceil((Date.parse(trimmed) - now) / 1000);
  if (!Number.isFinite(seconds) || seconds <= 0)
    seconds = RATE_LIMIT_DEFAULT_SECONDS;
  return Math.min(seconds, RATE_LIMIT_MAX_SECONDS);
}

export function toErrorDetail(error: unknown): ErrorDetail {
  if (error instanceof HttpErrorResponse && error.status === 429) {
    return {
      kind: 'rate-limit',
      retryAfterSeconds: parseRetryAfter(error.headers?.get('Retry-After')),
    };
  }
  return { kind: 'generic' };
}
